/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchOverdueTxnList } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchOverdueTxnList = createAsyncThunk('get/overdueTxnList', FetchOverdueTxnList);

export const FetchOverdueTxnSlice = createSlice({
	name: 'fetchOverdueTxnList',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchOverdueTxnList.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchOverdueTxnList.rejected.toString()]: setAPIError,
		[fetchOverdueTxnList.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchOverdueTxnSlice.name]: ReturnType<typeof FetchOverdueTxnSlice.reducer>;
}

export const fetchOverdueTxnSelector = (state: IStates): any => {
	return state[FetchOverdueTxnSlice.name] || {};
};

export const useOverdueTxnList = (): any => useSelector(fetchOverdueTxnSelector);

export const getOverdueTxnList =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchOverdueTxnList());
		return;
	};

export const resetOverdueTxnList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchOverdueTxnSlice.actions.RESET());
		return;
	};
